<template>
<div>
  
  <div class="landing">
    <div class="box is-darkish">
      <div class="capture content container">
        <div class="">
          <div class="cta">
            <br/>
            <h1 v-html="landing.headline"/>
            <p id="haiku">Enter the address of your
              {{landing.publication}}.
              {{landing.whatsinside}}
            We'll print and deliver. Quick and Easy.</p>
            <index-launcher location="homehero" title=""
                            :placeholder="landing.placeholder"
                            :cms="$route.params.cms"
                            drop-button></index-launcher>
            <!--div id="index-instructions">
              Enter the URL address of your blog to preview your book built
              from your blog posts.
            </div-->
          </div>

          <div class="foot">
            <table class="proof">
              <tr class="greatness">
                <td><img src="https://cdn.trustpilot.net/brand-assets/4.1.0/stars/stars-5.svg"
                     style="width:7em;"/></td><td>4.9&nbsp;TrustPilot</td>
              </tr>
              <tr class="greatness">
                <td><span>
                  <b-icon class="star" icon="star"/>
                  <b-icon class="star" icon="star"/>
                  <b-icon class="star" icon="star"/>
                  <b-icon class="star" icon="star"/>
                  <b-icon class="star" icon="star"/></span>
                </td><td>5.0&nbsp;Facebook</td>
              </tr>
            </table>

            
            <div class="supports">
              <p>We can make your book from Instagram, Wordpress,
                 Blogger, Tumblr, Squarespace, Wix, TravelArk,
                 and many others!</p>
              <!--
              <img src="/static/instagram-logo-128.png" alt="Instagram logo" title="We support Instagram!" class="logo"/>
              <img src="/static/wordpress-logo-128.png" alt="WordPress logo" title="We support WordPress!" class="logo"/>
              <img src="/static/blogger-logo-128t.png" alt="Blogger logo" title="We support Blogger!" class="logo"/>
              <img src="/static/tumblr-logo-128t.png" alt="Tumblr logo" title="We support Tumblr!" class="logo"/>
              <img src="/static/squarespace-logo-128t.png" alt="Squarespace logo" title="We support Squarespace!" class="logo"/>
              <img src="/static/wix-logo-128t.png" alt="Wix logo" title="We support Wix!" class="logo"/>
              <img src="/static/rss-logo-128t.png" alt="RSS icon" title="We support RSS Feeds!" class="logo"/>
              <span title="We support other blogs too!">+others</span>
              -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--div class="arrow-down"/-->

  <section id="features" class="section">
    <div class="container">
      <!--h2 class="title has-text-centered">A Haiku of Happiness</h2-->
      <div class="tile tile-ancestor">
        <div class="tile promo-tile">
          <div class="card promo-card">
            <div class="card-content content">
              <span class="title is-5">The Forever Book</span> -
              Preserve your memories in a quality large hardcover
              book. Printed in high detail on sturdy pages, this is
              a book to treasure.
            </div>
            <b-image class="card-image" webp-fallback=".jpg" src="/static/promo-forever.webp"/>
          </div>
        </div>
        <div class="tile promo-tile">
          <div class="card promo-card">
            <div class="card-content content">
              <span class="title is-5">Beautiful Magic Design</span> -
              Magic pixies apply our <em>Real Book</em> design.  Clean,
              modern layout that looks like a book, not like a web
              page.
            </div>
            <b-image class="card-image" webp-fallback=".jpg" src="/static/promo-design.webp"/>
          </div>
        </div>
        <div class="tile promo-tile">
          <div class="card promo-card">
            <div class="card-content content">
              <span class="title is-5">In Minutes, Not Days!</span> -
              Create and preview your {{landing.book}} in just a few minutes.
              Mind you, printing and delivery will take some days.
            </div>
            <b-image class="card-image" webp-fallback=".jpg" src="/static/promo-minutes.webp"/>
          </div>
        </div>
      </div>
      <div class="content is-medium">
        <p> PixxiBook <b>transforms your {{landing.publication}} into a
          Real Book</b> with ease. You have already put great effort
          into creating your {{landing.publication}}: selecting the
          best photos and writing outstanding {{landing.text}}. Now, use
          PixxiBook to leverage all of that effort to create your own
          {{landing.book}} in a few simple steps.</p>
        <p>
          Our <b>streamlined</b> and <b>automated</b> creation process will have your
          book ready <b>in minutes</b>. You can <b>customise the cover</b> to
          your own style. The preview will show you exactly how your
          book will look when printed.</p>
      </div>
      <div class="see-more">
        <router-link to="/doc/formats">Discover more about our quality books...</router-link>
      </div>
    </div>
  </section>

  <section id="testimonials" class="is-darkish section">
    <div class="container">
      <h2 class="title has-text-centered">Quick and Easy, Loved by Customers</h2>
      
      <div class="content is-medium"><center>Our <b><i>Real Books</i></b> are awesome but we are also <b><i>Real
      People</i></b> working behind the scenes.<br/> That's why we have consistent
          <span><b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/></span> product and
          <span><b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/>
            <b-icon class="star" icon="star"/></span> service ratings.
      </center></div>
      <div class="elfsight-wrapper">
        <div class="elfsight-app-7d4c9217-9656-4a92-88b7-e8319acdd2f5"
             data-elfsight-app-lazy/>        
      </div>
      <div class="see-more">
        <a target="_blank" href="https://www.trustpilot.com/review/www.pixxibook.com">
          See more reviews on TrustPilot</a>
        <a target="_blank" href="https://facebook.com/pixxibook/reviews">
          and FaceBook...</a>
      </div>
    </div>
  </section>
  <!--div class="arrow-down is-darkish"/-->

  <section id="gallery" class="section">
    <div class="container">
      <h2 class="title has-text-centered">Exact preview of your
      {{landing.book}}, Instant and Free</h2>
      <div class="content is-medium">
        Here you can see some example books, each made from a
        different one our supported hosts, <b>Wordpress</b>, <b>Blogger</b>, and
        <b>Squarespace</b>. We also fully support <b>Instagram</b>
        and <b>Tumblr</b> and do pretty well with a range
        of <router-link to="/doc/supported-blog-hosts">other blog
        platforms</router-link>. Just like these, you will be able to
        see an <b>exact preview</b> of your own book before going to
        print.
      </div>
      <div class="tile tile-ancestor">
        <div class="tile promo-tile">
          <gallery-card
             bookid="5tdm_xyz-611645673"
             image="/static/5tdm_xyz_cover_small.jpg"
             title="Travel Blog to Book">
            <div class="logo">
              <img src="/static/wordpress-logo-128.png" alt="WordPress Logo"/>A <b>WordPress</b> blog book.
            </div>
            <div class="blurb">
              Family gap year becomes coffee table book.
            </div>
          </gallery-card>
        </div>
        <div class="tile promo-tile">
          <gallery-card
             bookid="svfieldtrip_blogspot_com-762906699"
             image="/static/svfieldtrip_blogspot_com_cover_small.jpg"
             title="Ocean Going Family">
            <div class="logo">
              <img src="/static/blogger-logo-128.png" alt="Blogger Logo"/>A <b>Blogger</b> blog book.
            </div>
            <div class="blurb">
              Long running circumnavigation in many volumes.
            </div>
          </gallery-card>
        </div>
        <div class="tile promo-tile">
          <gallery-card
             bookid="www_hotspot-hunter_com-456254154"
             image="/static/hotspot-hunter_com_cover_small.jpg"
             title="Foodie Fantastic">
            <div class="logo">
              <img src="/static/squarespace-logo-128.png" alt="Squarespace Logo"/>A <b>Squarespace</b> blog book.
            </div>
            <div class="blurb">
              A book that's good enough to eat.
            </div>
          </gallery-card>
        </div>
      </div>
      <div class="see-more">
        <router-link to="/gallery">See more examples in the Blog Book Gallery...</router-link>
      </div>
    </div>
  </section>

  <section id="padding" class="section">
    <div class="container box">
        <index-launcher title="Sounds good? Let's print your blog!"
                        :cms="$route.params.cms"></index-launcher>
    </div>
  </section>
  
  </div>

</template>

<script>
import IndexLauncher from '@/components/IndexLauncher'
import GalleryCard from '@/components/GalleryCard'

// metaTitle is wrapped by App.vue's 'PixxiBook | %s' titleTemplate.
const LANDINGS = {
  generic: {
    metaTitle: 'Easy Blog to Book',
    metaDesc: 'Print your blog as a beautiful hardcover book. WordPress, Blogger, Instagram, Tumblr, Squarespace and more. Free preview in minutes, printed and delivered.',
    metaImage: 'https://pixxibook.com/static/pixxi-layouts.jpg',
    headline: 'Print your blog or Instagram book!',
    whatsinside: 'See the book preview immediately.',
    placeholder: undefined,
    publication: 'blog or instagram',
    book: 'blog book',
    text: 'text',
  },
  instagram: {
    metaTitle: 'Print your Instagram Photo Book - with Captions',
    metaDesc: 'Print your Instagram photos with their captions in a beautiful hardcover book. Automatic layout, a free preview in minutes, then printed and delivered.',
    headline: 'Print your Instagram Photo Book!',
    whatsinside: 'See the book preview immediately with your photos and captions.',
    placeholder: 'https://instagram.com/myusername',
    publication: 'Instagram',
    book: 'Instagram photo book',
    text: 'captions',
  },
  wordpress: {
    metaTitle: 'Print Your WordPress Blog as a Hardcover Book',
    metaDesc: 'Turn your WordPress blog into a hardcover book - wordpress.com or self-hosted. Automatic layout, a free preview in minutes, then printed and delivered.',
    headline: 'Print your WordPress book!',
    placeholder: 'myblog.wordpress.com',
    publication: 'blog',
    book: 'WordPress blog book',
  },
  blogger: {
    metaTitle: 'Print Your Blogger or Blogspot Blog as a Book',
    metaDesc: 'Turn your Blogger or Blogspot blog into a beautiful hardcover book. Automatic layout, a free preview in minutes, then printed and delivered to your door.',
    headline: 'Print your Blogger book!',
    placeholder: 'myblog.blogspot.com',
    publication: 'blog',
    book: 'Blogger blog book',
  },
  tumblr: {
    metaTitle: 'Print Your Tumblr Blog as a Hardcover Book',
    metaDesc: 'Turn your Tumblr blog into a beautiful hardcover book. Automatic layout of your posts and photos, a free preview in minutes, then printed and delivered.',
    headline: 'Print your Tumblr!',
    placeholder: 'myname.tumblr.com',
    publication: 'Tumblr',
    book: 'Tumblr book',
    text: 'captions',
  },
}

export const DISTINCT_CMS_PAGES = Object.keys(LANDINGS).filter(cms => cms != 'generic')

function getLanding(which)
{
  var landing = LANDINGS.generic
  if (LANDINGS[which]) {
    landing = Object.assign({}, landing, LANDINGS[which])
  }
  console.log('Landing',which,'->',landing)
  return landing
}

export default {
  name: 'HomePage',
  components: {
    GalleryCard,
    IndexLauncher,
  },
  data: function() { return {
    landing: getLanding(this.$route.params.cms)
  } },
  created() {
    console.log(this.landing)
  },
  metaInfo() { return {
    title: this.landing.metaTitle || 'Easy Blog to Book',
    meta: [
      { vmid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
      { vmid: 'og:image', name: 'og:image', content: this.landing.metaImage },
      { vmid: 'og:title', name: 'og:title', content: this.landing.metaTitle },
      { vmid: 'description', name: 'description', content: this.landing.metaDesc },
      { vmid: 'og:description', name: 'og:description', content: this.landing.metaDesc },
    ]
  }},
}
</script>

<style scoped>
#haiku {
    font-size: 140%;
    max-width: 20em;
}
.greatness {
    font-size: 120%;
}
.greatness img.stars {
    max-height: 1em;
}
.bg-image {
    background-size: cover;
    width: 100%;
    height: 100%;
}
@media screen and (max-width: 1024px) {
 .expo {
     position: absolute;
     top: 5rem; right: 0;
     width: 20rem;
     max-width: 40vw !important;
     z-order: -1;
 }
}
@media screen and (min-width: 1024px) {
}

.hero .hero-body .container {
  max-width: 60em;
  margin: auto;
}
.landing {
    background: #363636;
    background: linear-gradient(180deg, #363636 20%, white 100%);
    top: 0;
    padding: 0;
}
.landing .box {
    border-radius: .5em;
    xbox-shadow: 10px 10px 5px;
    padding-top: 13px;
    xborder: 1px solid #363636;
    xoutline: 1px solid #363636;
    xoutline-offset: -5px;

    background-color: rgba(0,0,0,0);
    background-image: url("/static/bookhero-3-1920-q70.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center bottom;
}
.landing .column {
    padding: 1em .5em;
}
.landing .capture {
    margin-left: 10%;
    max-width: 40em;
    z-index: 1;
}
.landing .capture .content {
    xposition: relative;    
}
.landing .capture .foot {
    xposition: relative;    
}
.landing .capture .proof {
    margin-top: 1em;
    width: auto;
}
.landing .capture .proof td {
    border: 0;
    padding: 0 1ex;
}
.landing .capture .proof.quote {
    color: black;
    max-width: 90%;
    margin: auto;
    background: white;
    border: 1px solid lightgrey;
    padding: 1ex;
    border-radius: 1ex;
    opacity: 0.8;
}
.landing .capture .proof.quote img {
    width: 8em;
    border-radius: 50%;
    display: inline-block;
}
.landing .capture .proof.quote div {
    padding-left: 1em;
    display: inline-block;
}
.landing .capture .supports {
    xbackground: white;
    opacity: 0.9;
    margin: 2em auto;
}
.landing .capture .supports .logo {
    width: 4em;
    max-width: 10vw;
}

.landing .expo {
    max-width: 50em;
    padding-right: 2em;
}
.arrow-down {
    width: 0;
    height: 0;
    background: transparent !important;
    position: relative;
    left: calc(50% - 3rem);
    border-left: 2rem solid transparent !important;
    border-right: 2rem solid transparent !important;
    border-top: 1rem solid #ff3860;
    xmargin-top: 0.75rem;
    xmargin-top: calc(-1.5rem + 0.75rem);
    xmargin-top: -1.5rem;
}

.cta {
  margin-bottom: 6em; 
}
.foot {
  margin-bottom: 6em; 
}
#index-instructions {
    opacity: 0;
    transform: scale(0.1);
    transform-origin: top left;
    transition: opacity 200ms, transform 200ms;
    color: white;
    background: rgba(1,1,1,0.4);
    border-radius: 1ex;
    padding: 1rem;
    margin-top: 1em;
    min-width: 30ex;
    width: 50%;
    margin-right: auto;
    margin-left: 10%;
    position: relative;
    display: inline-block;
}
#index-instructions:after {
    content: "";
    position: absolute;
    display: block;
    top: -2rem;
    height: 2rem;
    left: 2rem;
    bottom: auto;
    background: ;
    border-style: solid;
    border-color: transparent rgba(1,1,1,0.4);
    border-width: 2rem 0 0 1rem;
}
.cta:hover #index-instructions {
    opacity: 1;
    transform: scale(1.0);
}
.hero .hero-body { padding: 2rem 1.5rem; }


section {
    padding-top: 0.5em;
    padding-bottom: 1.5em;
}
section h2 {
    padding-top: 1em;
}
.see-more {
    text-align: right;
    padding-right: 2em;
    font-size: 120%;
}

.features .tile-ancestor {
    max-width: 75rem;
}
.promo-tile {
    padding: 1em;
    max-width: 30rem;
}
.promo-tile .logo {
    margin-top: 1ex;
    font-style: italic;
    text-align: center;
}
.promo-tile .logo img {
    max-height: 32px;
    vertical-align: middle;
}
.promo-tile .blurb {
    margin-left: 2em;
}
.promo-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.promo-card .card-content {
    background: #c0a0b0;
    color: white;
    padding-top: 1ex;
    padding-bottom: 1ex;
    margin: 0;
}
.promo-card .card-content .title {
    color: white;
}
.section#features .tile-ancestor {
    margin-bottom: 2ex;
}

.is-dark {
    background: #363636;
    color: white !important;
}
.is-dark .content h1 {
    text-stroke: 3px black;
    color: white !important;
}
.is-darkish {
    background-color: #c0a0b0;
}
.is-darkish,
.is-darkish h2,
.is-darkish .content h1
{
    color: white !important;

}
.blurb {
}

.centred {
    margin: auto;
}

.elfsight-wrapper {
    min-height: 500px;    
}
.star {
    color: rgb(255, 180, 0);
}
.star:not(:first-child) {
    margin-left: -8px;
}
</style>





// WEBPACK FOOTER //
// src/components/HomePage.vue